var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contents"},[_c('top'),_c('sub-dialog',{attrs:{"visible":_vm.subdialogvis}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }